import { cn } from "@needl-ai/common/lib/utils";

import ChatInputCard from "./ChatInputCard";

import type { Message } from "@/types/chat";
import type { ReactNode } from "react";

const ChatInputWrapper = ({
  value,
  onChange,
  onSend,
  onStop,
  disabled = false,
  isStreaming = false,
  placeholder,
  messages = [],
  cap,
}: ChatInputWrapperProps) => {
  const handleSend = () => {
    onSend();
  };

  const getPlaceholder = () => {
    if (placeholder) return placeholder;

    if (Array.isArray(messages) && messages.length === 0) {
      return "Enter client details, portfolio information, or investment goals...";
    }
    return "Type your message here...";
  };

  return (
    <div>
      <div className="w-full max-w-3xl mx-auto">
        <div
          className={cn(
            "border rounded-3xl backdrop-blur-sm w-full bg-white/95 hover:shadow-md transition-shadow duration-200 dark:bg-neutral-900/95 dark:shadow-md overflow-hidden",
            cap
              ? "border-amber-400 dark:border-amber-600"
              : "border-gray-200/80 dark:border-neutral-700/80"
          )}
        >
          {cap}
          <ChatInputCard
            value={value}
            onChange={onChange}
            onSend={handleSend}
            onStop={onStop}
            disabled={disabled}
            isStreaming={isStreaming}
            placeholder={getPlaceholder()}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatInputWrapper;

type ChatInputWrapperProps = {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  onStop: () => void;
  disabled?: boolean;
  isStreaming?: boolean;
  placeholder?: string;
  messages?: Message[];
  className?: string;
  cap?: ReactNode;
};
